<template>
  <div>
    <v-data-table
      colspan="100%"
      no-data-text="Nenhum bot cadastrado"
      :headers="headers"
      :items="items"
      :footer-props="{
        'items-per-page-text': 'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
    >
      <template
        #[`item.nome`]="{ item }"
      >
        <router-link
          :to="{ name: 'bot', params: { id: item.id }}"
          class="text--primary text-truncate cursor-pointer text-decoration-none"
        >
          <v-list-item class="ml-n4">
            <div class="d-flex align-center">
              <v-avatar
                :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
                size="32"
              >
                <span
                  :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold
                `"
                >
                  {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
                </span>
              </v-avatar>

              <div class="d-flex flex-column ms-3">
                {{ item.nome }}
              </div>
            </div>
          </v-list-item>
        </router-link>
      </template>

      <template #[`item.descricao`]="{ item }">
        <div class="d-flex align-center">
          {{ item.descricao }}
        </div>
      </template>

      <template #[`item.statusNome`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.statusNome === 'Ativo' ? 'success--text' : 'secondary--text'}`"
          :color="`${item.statusNome !== 'Ativo' ? 'success' : 'secondary'}`"
        >
          {{ item.statusNome === 'Ativo' ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              color="primary"
              v-on="on"
              @click="ativarOuInativarItem(item)"
            >
              <v-icon>
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                role="button"
                class="d-flex"
                @click="openDialogAtivarOuInativarItem"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ isChatBotAtivo ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize">{{ isChatBotAtivoMensagem }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogAtivarOuInativarItem"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline text-capitalize">
          {{ isChatBotAtivoMensagem }}
        </v-card-title>
        <v-card-text>{{ `Tem certeza que vai ${isChatBotAtivoMensagem} este chat bot?` }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="closeDialogAtivarOuInativarItem"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="confirmarAtivacaoOuInativacaoItem"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secundary"
            ></v-progress-circular>
            <span v-else>OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiCheckBold, mdiCloseThick, mdiDotsVertical } from '@mdi/js'
import ChatBotService from '@/services/modules/ChatBotService'

export default {
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => {},
    },
  },

  setup(_, { emit }) {
    const dialogAtivarOuInativarItem = ref(false)
    const loading = ref(false)
    const chatBotId = ref(0)
    const isChatBotAtivo = ref(undefined)
    const isChatBotAtivoMensagem = ref('')

    const ativarOuInativarItem = item => {
      chatBotId.value = item.id
      isChatBotAtivo.value = item.statusNome === 'Ativo'
      isChatBotAtivoMensagem.value = item.statusNome === 'Ativo' ? 'inativar' : 'ativar'
    }
    const openDialogAtivarOuInativarItem = () => {
      dialogAtivarOuInativarItem.value = true
    }
    const closeDialogAtivarOuInativarItem = () => {
      dialogAtivarOuInativarItem.value = false
    }
    const confirmarAtivacaoOuInativacaoItem = async () => {
      try {
        loading.value = true
        await ChatBotService.atualizarStatus(chatBotId.value, {
          statusId: isChatBotAtivo.value ? 2 : 1,
        })
        emit('confirmar-ativacao-inativacao')
      } finally {
        closeDialogAtivarOuInativarItem()
        loading.value = false
      }
    }

    return {
      dialogAtivarOuInativarItem,
      loading,
      isChatBotAtivo,
      isChatBotAtivoMensagem,
      ativarOuInativarItem,
      openDialogAtivarOuInativarItem,
      closeDialogAtivarOuInativarItem,
      confirmarAtivacaoOuInativacaoItem,
      icons: {
        mdiCheckBold,
        mdiCloseThick,
        mdiDotsVertical,
      },
    }
  },
}
</script>
